import React from "react";

const CaddieIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 14.3592 25.7671"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9298,9.613c0,-0.495 -0.5242,-1.069 -1.4131,-1.069h-6.2392c-0.898,0 -1.4131,0.582 -1.4131,1.069v2.237c-0.0001,1.583 -0.4723,2.462 -0.9248,3.178c-0.4354,0.688 -0.7393,1.089 -0.7393,1.878v3.863c0,0.561 0.5894,1.195 1.5674,1.195h7.749c0.8976,0 1.4129,-0.58 1.4131,-1.067zM13.13,20.897c-0.0002,1.346 -1.2678,2.267 -2.6133,2.267h-7.749c-1.4193,0 -2.7676,-0.97 -2.7676,-2.395v-3.863c0,-1.196 0.5284,-1.892 0.9249,-2.519c0.3791,-0.6 0.7391,-1.257 0.7392,-2.537v-2.237c0,-1.347 1.2676,-2.268 2.6133,-2.268h6.2392c1.3239,0 2.6133,0.904 2.6133,2.268z"
        fill="currentColor"
      />
      <path
        d="M4.8594,15.854c0,-0.946 -0.535,-1.812 -1.3818,-2.236l-1.3418,-0.671l0.4472,-0.894l1.3418,0.671c1.1857,0.593 1.9346,1.805 1.9346,3.13v7.146h-1z"
        fill="currentColor"
      />
      <path
        d="M2.8185,24.325v-1.467h1.1992v1.467c0,0.127 0.1064,0.242 0.2539,0.242h5.4522c0.1485,0 0.2529,-0.116 0.2529,-0.242v-1.761h1.2002v1.761c0,0.792 -0.6449,1.442 -1.4531,1.442h-5.4522c-0.7834,0 -1.4531,-0.625 -1.4531,-1.442z"
        fill="currentColor"
      />
      <path
        d="M9.7881,3.283v4.717h-1v-4.717z"
        fill="currentColor"
      />
      <path
        d="M9.9652,4.831l0.026,-1.262c0,-0.144 0.0521,-0.274 0.1562,-0.378c0.1823,-0.169 0.3775,-0.143 0.4946,-0.13c1.1064,0.13 1.536,0.312 2.1998,0.26c0.2082,-0.013 1.1324,-0.052 1.4318,-0.781c0.1822,-0.455 0.0781,-1.21 -0.3515,-1.77c-0.5727,-0.742 -1.4057,-0.768 -1.6791,-0.768c-0.872,-0.026 -2.421,0.169 -3.0327,0.885c-0.5467,0.651 -0.5858,1.51 -0.5858,1.771v2.147h1.3407z"
        fill="#1A8B5A"
      />
      <path
        d="M5.8594,3v5h-1v-5z"
        fill="currentColor"
      />
      <path
        d="M5.9437,4.831l0.0261,-1.262c0,-0.144 0.052,-0.274 0.1561,-0.378c0.1823,-0.169 0.3775,-0.143 0.4947,-0.13c1.1063,0.13 1.5359,0.312 2.1997,0.26c0.2083,-0.013 1.1324,-0.052 1.4318,-0.781c0.1822,-0.455 0.0781,-1.21 -0.3515,-1.77c-0.5727,-0.742 -1.4187,-0.768 -1.679,-0.768c-0.8721,-0.026 -2.4211,0.169 -3.0328,0.885c-0.5467,0.651 -0.5857,1.51 -0.5857,1.771v2.147h1.3406z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default CaddieIcon;
